// src/views/Estados/VerEstados.jsx
import React from "react";

export default function VerEstados({ id, onClose = () => {} }) {
  // Datos mockeados (deben coincidir con ListarEstados.jsx)
  const items = [
    { id: 1, nombre: "CLIENTES", descripcion: "Estados de clientes" },
    {
      id: 2,
      nombre: "SOLICITUD DE LIMITE DE CREDITO",
      descripcion: "Estados de solicitud de límite",
    },
    { id: 3, nombre: "PRODUCTOS", descripcion: "Estados de productos" },
    {
      id: 4,
      nombre: "PRODUCTOS POR ESTACION",
      descripcion: "Estados por estación",
    },
    { id: 5, nombre: "PIN", descripcion: "Estados de PIN" },
    { id: 6, nombre: "TARJETA FLOTA", descripcion: "Estados de tarjeta flota" },
    { id: 7, nombre: "REMITOS", descripcion: "Estados de remitos" },
    { id: 8, nombre: "LIQUIDACION", descripcion: "Estados de liquidación" },
    {
      id: 9,
      nombre: "FACTURA DE CLIENTES",
      descripcion: "Estados de facturas",
    },
    {
      id: 10,
      nombre: "LIQUIDACION DE CLIENTES",
      descripcion: "Estados de liquidación de clientes",
    },
  ];

  // Buscar el estado seleccionado
  const estado = items.find((x) => x.id === id);

  if (!estado) {
    return (
      <div className="modal-backdrop">
        <div className="modal-panel-lg">
          <div className="modal-header">
            <h2 className="section-title">Tipo de Estado no encontrado</h2>
          </div>
          <div className="modal-body text-center py-6 text-gray-600">
            No se encontró información para ID: {id}
          </div>
          <div className="modal-footer">
            <button className="btn-fil" onClick={onClose}>
              Cerrar
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-backdrop">
      <div className="modal-panel-lg">
        {/* Encabezado */}
        <div className="modal-header">
          <h2 className="section-title">Visualizar Tipo de Estado</h2>
        </div>

        {/* Datos */}
        <div className="modal-body">
          <div className="form-grid mb-4">
            <Fila label="Tipo de estado:" value={estado.nombre} />
          </div>
        </div>

        {/* Footer */}
        <div className="modal-footer">
          <button className="btn-fil" onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}

function Fila({ label, value }) {
  return (
    <div className="form-row">
      <div className="form-label">{label}:</div>
      <div className="value">{value || ""}</div>
    </div>
  );
}
